import styled from 'styled-components';
var Container = styled.div.withConfig({
  displayName: "SizeGuidestyles__Container",
  componentId: "jqbajn-0"
})(["display:flex;flex-direction:column;"]);
var NotFound = styled.h2.withConfig({
  displayName: "SizeGuidestyles__NotFound",
  componentId: "jqbajn-1"
})(["&&{font-size:", ";font-weight:", ";}"], function (props) {
  return props.theme.font.size['body-2'];
}, function (props) {
  return props.theme.font.weight.bold;
});
export { Container, NotFound };